<template>
    <div
        id="error-container"
        class="APIError flex flex-center col-center"
    >
        <q-icon
            name="error_outline"
            color="red"
            size="48px"
            class="mb-1"
        />
        <WText
            tag="h3"
            :size="36"
            class="mb-3"
        >
            {{ $t('error.notfound.text') }}
        </WText>
        <QBtn
            color="primary"
            noCaps
            class="pl-1 pr-1"
            :label="$t('actions.retry')"
            @click="handleClickRetry"
        />
    </div>
</template>
<script>
import { Api, apiRequest, notifyError } from '@/api'

export default {
    name: 'APIError',
    methods: {
        handleClickRetry() {
            apiRequest(Api().organizations.list())
                .then(() => this.$router.push({ name: 'Main' }))
                .catch(notifyError)
        },
    },
}
</script>
